import * as actionTypes from '../actionTypes/contentGeneration';

export default {
  addGeneratedData: (params) => ({
    type: actionTypes.ADD_CONTENT_GENERATION_DATA,
    payload: params,
  }),
  updateGeneratedData: (params) => ({
    type: actionTypes.SET_CONTENT_GENERATION_DATA,
    payload: params,
  }),
  resetGeneratedData: () => ({
    type: actionTypes.RESET_CONTENT_GENERATION_DATA,
  }),
  deleteGeneratedData: (params) => ({
    type: actionTypes.DELETE_CONTENT_GENERATION_DATA,
    payload: params,
  }),
};
